//#region Dependencias
import React, { Component } from 'react';
import {
    BreadCumb,
    DataTables,
    InventoryCountingCreateModal,
    NavBar,
    TimeOut
} from "../../components";
import config from "../../config";
import moment from "moment";
import {
    DISPATCH_ID,
    SERVICE_RESPONSE
} from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient";
import { connect } from "react-redux";
import $ from "jquery";
import { InventoryCounting, InventoryCountingLine } from '../../components/NewOrder';
import './InventoryCounting.css';
//#endregion

//#region Variables globales
const apiClient = ApiClient.getInstance();
const statusFormat = (status) => { switch (status) { case 'O': return 'Abierto'; case 'C': return 'Cerrado'; default: return 'Pendiente'; } }
const dateFormat = (date) => { return moment(date).format("YYYY-MM-DD"); }
const timeFormat = (time) => { return Number(time) > 999 ? `${time.toString().substring(0, 2)}:${time.toString().substring(2)}` : `0${time.toString().substring(0, 1)}:${time.toString().substring(1)}`; }
const countTypeFormat = (type) => { switch (Number(type)) { case 1: return 'Encargado de recuento simple'; case 2: return 'Encargado de recuento multiple'; default: return ''; } }

const headersDataTable = [
    { title: "N° Doc", value: true, field: "DocNum", format: null, classes: "text-left" },
    { title: "Serie", value: true, field: "Series", format: null, classes: "text-left" },
    { title: "Estatus", value: true, field: "Status", format: statusFormat, classes: "text-center" },
    { title: "Fecha", value: true, field: "CountDate", format: dateFormat, classes: "text-right" },
    { title: "Hora", value: true, field: "Time", format: timeFormat, classes: "text-right" },
    { title: "Tipo de recuento", value: true, field: "CountType", format: countTypeFormat, classes: "text-left" },
    { title: "Comentarios", value: true, field: "Remarks", format: null, classes: "text-left" },
];
//#endregion

//#region Componente
class InventoryCountingView extends Component {
    //#region Acciones del componente
    constructor(props) {
        super(props)
        this.state = {
            view: "inventoryCounting",
            headers: headersDataTable,
            showCreateModal: false,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser")),
            inventoryCountingModel: new InventoryCounting(),
            itemsList: [],
            usersList: [],
            employeesList: [],
            locationsList: [],
            priceListArray: [],
            action: 1,
        }
    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liReturnRequest");
        let today = moment(new Date()).format("YYYYMMDD");

        let date = {
            dateInit: today,
            dateFinal: today,
        }
        await this.callDocumentsListService(date);
        await this.getDataLists();
    }
    //#endregion

    //#region Consultar Información
    callDocumentsListService = async (filters = {}) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        // Filtros de búsqueda de los documentos
        let data = {
            table: "OINC",
            filters: {
                dateInit: filters.dateInit || moment().format("YYYY-MM-DD"),
                dateEnd: filters.dateFinal || moment().format("YYYY-MM-DD"),
                status: filters.docStatus || '---',
                series: filters.searchSerieName || '--',
                docNum: filters.docNumSearch || '--',
            }
        };

        enableSpinner(true);
        let docsListResponse = await apiClient.inventoryDocumentsList(data);
        enableSpinner(false);

        if (docsListResponse.status === SERVICE_RESPONSE.SUCCESS) {
            docsListResponse = docsListResponse.data || [];
            let newDocumentsfilterSeries = docsListResponse || [];

            // Proceso para validar series validas
            // let dataSerie = { docType: "1470000065", docSubType: "--" };

            // enableSpinner(true);
            // let seriesResponse = await apiClient.getSeries(dataSerie);
            // seriesResponse = seriesResponse.data || [];
            // enableSpinner(false);

            // let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            // let ValidateSeries = user.U_FMB_ValidateSeriesORRR ? user.U_FMB_ValidateSeriesORRR : "";

            // if (!user || !ValidateSeries || ValidateSeries === "") {
            //     this.setState({ data: [] });
            //     return showAlert({ type: 'warning', message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador",  timeOut: 5000 });
            // }

            // let seriesUsers = ValidateSeries.split("|") || [];

            // let newArraySeries = seriesUsers?.filter(SeriesUser => seriesResponse.some(({Series}) => Number(SeriesUser) === Number(Series))) || [];

            // if (newArraySeries.length === 0) { return showAlert({ type: 'warning', message: "El usuario no tiene serie permitida de escritura y lectura", timeOut: 5000 }); }

            // let newDocumentsfilterSeries = docsListResponse.filter(({SeriesCode}) => newArraySeries.some(Series => Number(SeriesCode) === Number(Series))) || [];

            // if(( filters.docNumSearch && filters.docNumSearch !== '--' ) || ( filters.searchSerieName !== '--' && filters.searchSerieName )){ newDocumentsfilterSeries = docsListResponse || []; }

            // if (newDocumentsfilterSeries.length === 0) {
            //     this.setState({ data: [] });
            //     return showAlert({ type: 'info', message: "No se encontraron resultados correspondientes a la búsqueda.", timeOut: 5000 });
            // }

            this.setState({ data: newDocumentsfilterSeries });
            return;
        } else {
            this.setState({ data: [] });
            return showAlert({ type: 'info', message: "No se encontraron resultados correspondientes a la búsqueda.", timeOut: 5000 });
        }
    };

    openDocumentDetails = async (docEntry, modalActive = false) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        const data = {
            table: "OINC",
            docEntry,
        };

        enableSpinner(true);
        const detailsResponse = await apiClient.inventoryDocumentDetails(data);
        enableSpinner(false);

        if (detailsResponse.status === SERVICE_RESPONSE.SUCCESS) {
            const header = detailsResponse.data.header;
            const lines = detailsResponse.data.items;

            let inventoryCountingModel = new InventoryCounting();
            
            inventoryCountingModel.DocumentEntry = docEntry;
            inventoryCountingModel.ObjectType = header.ObjType || '';
            inventoryCountingModel.DocumentNumber = header.DocNum || '';
            inventoryCountingModel.Series = header.Series || '';
            inventoryCountingModel.SeriesName = header.SeriesName || '';
            inventoryCountingModel.CountDate = dateFormat(header.CountDate || new Date());
            inventoryCountingModel.CountTime = timeFormat(header.Time || 1200);
            inventoryCountingModel.DocumentStatus = header.Status || '';
            inventoryCountingModel.SingleCounterType = header.Taker1Type || '12';
            inventoryCountingModel.SingleCounterID = header.Taker1Id || '-1';
            inventoryCountingModel.SingleCounterName = header.Taker1Name || '';
            inventoryCountingModel.Remarks = header.Remarks || '';
            inventoryCountingModel.Reference2 = header.Ref2 || '';
            inventoryCountingModel.CountingType = header.CountType || 1;
            inventoryCountingModel.TeamCountersQty = header.TeamCount || 0;
            inventoryCountingModel.TeamCounters = header.TeamCounters || [];
            inventoryCountingModel.IndividualCountersQty = header.IndvCount || 0;
            inventoryCountingModel.IndividualCounters = header.IndividualCounters || [];

            let newLines = [];

            if (Array.isArray(lines)) {
                for (let i = 0; i < lines.length; i++) {
                    const currentLine = lines[i];
                    let newLine = new InventoryCountingLine();
    
                    newLine.DocumentEntry = docEntry;
                    newLine.LineNumber = currentLine.LineNum || 0;
                    newLine.ItemCode = currentLine.ItemCode || '';
                    newLine.ItemDescription = currentLine.ItemDesc || '';
                    newLine.Freeze = currentLine.Freeze || 'N';
                    newLine.WarehouseCode = currentLine.WhsCode || '';
                    newLine.BinEntry = currentLine.BinEntry || '';
                    newLine.BinCode = currentLine.BinCode || '';
                    newLine.InWarehouseQuantity = Number(currentLine.InWhsQty || 0.0).toFixed(3);
                    newLine.Counted = currentLine.Counted || 'N';
                    newLine.CountedQuantity = Number(currentLine.CountQty || 0.0).toFixed(3);
                    newLine.Variance = Number(currentLine.Difference || 0.0).toFixed(3);
                    newLine.VariancePercentage = Number(currentLine.DiffPercen || 0.0).toFixed(3);
                    newLine.LineStatus = currentLine.LineStatus || '';
                    newLine.IndividualCounters = currentLine.IndividualCounters || [];
                    newLine.WarehousesStocks = currentLine.wareHouses || [];
                    newLine.PricesList = currentLine.itemPrice || [];
    
                    newLines.push(newLine);
                }
            }

            inventoryCountingModel.InventoryCountingLines = newLines;

            await this.setState({inventoryCountingModel, action: 2});

            if (!modalActive) {
                await this.setState({ showCreateModal: true });
                $("#InventoryCountingCreateModal").modal("show");
                $("#InventoryCountingCreateModal").on("hidden.bs.modal", async () => {
                    await this.setState({ showCreateModal: false });
                });
            }
            return;
        }

        showAlert({ type: 'error', message: detailsResponse.message });
    }

    getDataLists = async () => {
        const { enableSpinner } = this.props;

        enableSpinner(true);

        let itemsList = [];
        let usersList = [];
        let employeesList = [];
        let locationsList = [];
        let priceListArray = [];

        await this.setState({  });

        // const itemListResponseAPI = await apiClient.getSuggestionsDocument({ view: 'transfers' });
        // if (itemListResponseAPI.status === SERVICE_RESPONSE.SUCCESS) { itemsList = itemListResponseAPI?.data ?? []; }

        const usersListResponseAPI = await apiClient.getSuggestionsDocument({ option: 'getUsers' });
        if (usersListResponseAPI.status === SERVICE_RESPONSE.SUCCESS) { usersList = usersListResponseAPI?.data ?? []; }

        const employeesListResponseAPI = await apiClient.getSuggestionsDocument({ option: 'getEmployees' });
        if (employeesListResponseAPI.status === SERVICE_RESPONSE.SUCCESS) { employeesList = employeesListResponseAPI?.data ?? []; }

        priceListArray = await apiClient.getPriceList();
        priceListArray = Array.isArray(priceListArray?.data) ? priceListArray.data : [];

        // const locationsListResponseAPI = await apiClient.getSuggestionsDocument({ option: 'getLocations' });
        // if (locationsListResponseAPI.status === SERVICE_RESPONSE.SUCCESS) { locationsList = locationsListResponseAPI?.data ?? []; }

        await this.setState({ itemsList, usersList, employeesList, locationsList, priceListArray });
        
        enableSpinner(false);
    }
    //#endregion

    //#region Crear nuevo documento
    createDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { inventoryCountingModel } = this.state;

        try {
            enableSpinner(true);

            let data = {
                table: inventoryCountingModel.ObjectType === '1470000065' ? "OINC" : "OIQR",
                model: inventoryCountingModel,
            };
    
            let responseArray = [];    
            let response = await apiClient.createInventoryDocument(data);
    
            try {
                responseArray.push({
                    billing: response?.data?.docNumBilling || '',
                    docNum: response?.data?.DocNum || '',
                    message: response?.message || '',
                });
            } catch (e) {
                responseArray.push({
                    docNum: '',
                    billing: '',
                    message: '',
                });
            }

            this.setState({ billingResponseArray: responseArray })

            $("#billingResponseModal").modal("show");
            $("#billingResponseModal").on("hidden.bs.modal", () => { this.setState({ billingResponseArray: null }) });

            if (response.status === 1) { $('#InventoryCountingCreateModal').modal('hide'); }
            enableSpinner(false);
        } catch (e) {
            showAlert({ type: "error", message: JSON.stringify(e) });
            enableSpinner(false);
        }
    }

    createNewDocumentModel = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user, usersList } = this.state;
        const currentUser = usersList.find(({UserID}) => Number(UserID) === Number(_user.USERID)) || {};
        let inventoryCountingModel = new InventoryCounting();
                
        let dataSerie = {
            docType: inventoryCountingModel.ObjectType,
            docSubType: '--'
        };

        enableSpinner(true);
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let ValidateSeries = Array.isArray(seriesResponse?.data)? (seriesResponse.data.filter(({ ObjectCode }) => ObjectCode === inventoryCountingModel.ObjectType)) : [];
        let seriesUsers = user?.U_FMB_ValidateSeriesOINC;

        if (!user || !ValidateSeries.length || !seriesUsers) {
            return showAlert({ type: 'warning', message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador", timeOut: 5000 });
        }

        seriesUsers = seriesUsers.split("|");

        let newArraySeries = [];

        for (let index = 0; index < seriesUsers.length; index++) {
            const serieUser = seriesUsers[index];
            for (let index = 0; index < ValidateSeries.length; index++) {
                const serieResponse = ValidateSeries[index];
                if (serieResponse.Series.toString() === serieUser.toString()) {
                    newArraySeries.push(serieResponse);
                }
            }
        }

        if (newArraySeries.length === 0) {
            return showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
        }

        let defaultName = "";
        let defaultcode = "";
        let nextNumber = "";

        for (let index = 0; index < newArraySeries.length; index++) {
            const serie = newArraySeries[index];
            if (serie.Series.toString() === newArraySeries[0].DfltSeries.toString()) {
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber
            }
        }

        inventoryCountingModel.SerieArray = newArraySeries || [];
        inventoryCountingModel.Series = defaultcode;
        inventoryCountingModel.SeriesName = defaultName;
        inventoryCountingModel.DocumentNumber = nextNumber;
        inventoryCountingModel.ObjectType = "1470000065";
        inventoryCountingModel.CountDate = dateFormat(new Date());
        inventoryCountingModel.CountTime = timeFormat(moment(new Date()).format("HHmm"));
        inventoryCountingModel.SingleCounterID = currentUser.UserID || -1;
        inventoryCountingModel.SingleCounterName = currentUser.UserName || "";

        await this.setState({ showCreateModal: true, inventoryCountingModel, action: 1 });
        $("#InventoryCountingCreateModal").modal("show");
        $("#InventoryCountingCreateModal").on("hidden.bs.modal", async () => {
            await this.setState({ showCreateModal: false });
        });
    }

    updateModel = async (inventoryCountingModel) => {
        await this.setState({inventoryCountingModel});
    }
    //#endregion

    //#region Render
    render() {
        const {
            view,
            headers,
            data,
            _user,
            inventoryCountingModel,
            action,
            itemsList,
            usersList,
            employeesList,
            locationsList,
            priceListArray,
            billingResponseArray,
            showCreateModal,
        } = this.state;

        const { enableSpinner, notificationReducer: {showAlert} } = this.props;

        const actions = {
            openDocumentDetails: this.openDocumentDetails,
            createDocument: this.createNewDocumentModel,
        }

        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'RECUENTO DE INVENTARIO'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1 text-muted"> &nbsp; RECUENTO DE INVENTARIO </h2>
                    {showCreateModal &&
                        <InventoryCountingCreateModal
                            _user={_user}
                            view={view}
                            createDocument={this.createDocument}
                            model={inventoryCountingModel}
                            updateModel={this.updateModel}
                            action={action}
                            itemsList={itemsList}
                            usersList={usersList}
                            employeesList={employeesList}
                            locationsList={locationsList}
                            priceListArray={priceListArray}

                            enableSpinner={enableSpinner}
                            showAlert={showAlert}/>
                    }
                    <DataTables
                        headers={headers}
                        view={view}
                        data={data}
                        search={this.callDocumentsListService}
                        actions={actions}
                        billingResponse={billingResponseArray}/>
                </div>
            </div>
        );
    }
    //#endregion
}
//#endregion

//#region REDUX
const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};
//#endregion

export default connect(mapStateToProps, mapDispatchToProps)(InventoryCountingView); // Exportar componente